import { createRouter, createWebHistory } from 'vue-router';

import SingleLayout from '@/layout/SingleLayout.vue';
import AppLayout from '@/layout/AppLayout.vue';

import E404Page from '@/page/E404Page.vue';
import BlanckPage from '@/page/BlanckPage.vue';
import HomePage from '@/page/home/HomePage.vue';
import DashboardPage from '@/page/dashboard/DashboardPage.vue';
import DashboardExecutivoPage from '@/page/dashboard/DashboardExecutivoPage.vue';
import DashboardFinanceiroPage from '@/page/dashboard/DashboardFinanceiroPage.vue';

import LoginPage from '@/page/LoginPage.vue';
import EsqueciSenhaPage from '@/page/EsqueciSenhaPage.vue';
import AlterarSenhaPage from '@/page/AlterarSenhaPage.vue';

import UsuarioListaPage from '@/page/usuario/ListaPage.vue';
import SolicitanteListaPage from '@/page/solicitante/ListaPage.vue';
import PendenciaListaPage from '@/page/pendencia/ListaPage.vue';
import PerfilListaPage from '@/page/perfil/ListaPage.vue';

import ClienteListaPage from '@/page/cliente/ListaPage.vue';
import ContaListaPage from '@/page/conta/ListaPage.vue';
import ProvedorListaPage from '@/page/provedor/ListaPage.vue';
import ContratoListaPage from '@/page/contrato/ListaPage.vue';
import ContratoVigentePage from '@/page/contrato/VigentePage.vue';
import AgendamentoListaPage from '@/page/contrato/AgendamentoListaPage.vue';
import AprovacaoListaPage from '@/page/aprovacao/ListaPage.vue';
import CotacaoListaPage from '@/page/cotacao/ListaPage.vue';
import LogListaPage from '@/page/log/ListaPage.vue';
import CidadeListaPage from '@/page/cidade/ListaPage.vue';
import EstadoListaPage from '@/page/estado/ListaPage.vue';
import PendenciaCategoriaListaPage from '@/page/pendenciaCategoria/ListaPage.vue';

import Auth from '@/service/auth.js';

import Token from '@/utils/Token';


const routes = [
    {
        path: '',
        component: SingleLayout,
        beforeEnter: (to, from, next) => {
            if(Token.get()) {
                return next({ name: 'home'});
            }
            permissoes = {};
            return next();
        },
        children: [
            { path: ':catchAll(.*)', component: E404Page, },
            { path: '', redirect: { name: 'login' } },
            { path: '/login', component: LoginPage, name: 'login' },
            { path: '/esqueci-senha', component: EsqueciSenhaPage, name: 'esqueci-senha' },
            { path: '/alterar-senha/:token', component: AlterarSenhaPage, name: 'alterar-senha' },
        ],
    },
    {
        path: '/app',
        component: AppLayout,
        beforeEnter: (to, from, next) => {
            if(!Token.get()) {
                return next({ name: 'login', query: {error:'auth'} });
            }

            if (Object.keys(permissoes).length === 0) {

                Auth.permissoes()
                    .then(response => {
                        permissoes = response.data;

                        const event = new Event("onPermissios");
                        event.permissoes = permissoes;
                        document.dispatchEvent(event);
                    })
            }
            return next();
        },

        children: [
            { path: ':catchAll(.*)', component: E404Page, },
            { path: '', redirect: { name: 'home' } },

            // Operações
            { path: 'home', component:HomePage, name: 'home' },
            { path: 'dashboard', component: DashboardPage, name: 'dashboard' },
            { path: 'dashboard-executivo', component: DashboardExecutivoPage, name: 'dashboard-executivo' },
            { path: 'contrato', component: ContratoListaPage, name: 'contrato.lista' },
            { path: 'clientes', component: ClienteListaPage, name: 'cliente.lista' },
            { path: 'provedores', component: ProvedorListaPage, name: 'provedor.lista' },
            { path: 'cotacoes', component: CotacaoListaPage, name: 'cotacao.lista' },
            { path: 'pendencias', component: PendenciaListaPage, name: 'pendencia.lista' },
            { path: 'agendamentos', component: AgendamentoListaPage, name: 'agendamento.lista' },

            // Financeiro

            { path: 'dashboard-financeiro', component: DashboardFinanceiroPage, name: 'dashboard-financeiro' },
            { path: 'vigentes', component: ContratoVigentePage, name: 'conta.vigentes' },
            { path: 'contas', component: ContaListaPage, name: 'conta.lista' },

            // Administração
            { path: 'perfis', component: PerfilListaPage, name: 'perfil.lista' },
            { path: 'usuarios', component: UsuarioListaPage, name: 'usuario.lista' },
            { path: 'logs', component: BlanckPage, name: 'log.lista' },
            { path: 'estados', component: EstadoListaPage, name: 'estado.lista' },
            { path: 'cidades', component: CidadeListaPage, name: 'cidade.lista' },
            { path: 'pendencia-categoria', component: PendenciaCategoriaListaPage, name: 'pendencia-categoria.lista' },
            { path: 'solicitantes', component: SolicitanteListaPage, name: 'solicitante.lista' },
            { path: 'aprovacao', component: AprovacaoListaPage, name: 'aprovacao' },
            { path: 'log', component: LogListaPage, name: 'log.lista' },
        ]
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
